// Mappers for erp-related entities
// Identity mappers for 1:1 mapping

import type { AcquireEntityDetailsFromReplicaResponseDto } from '@api/generated/models';

import type { AcquireEntityDetailsFromReplicaResponse, ErpFieldsResponse } from '@api/domain/types';

// Response mappers (identity for 1:1)
export const toAcquireEntityDetailsFromReplicaResponse = (
  dto: AcquireEntityDetailsFromReplicaResponseDto
): AcquireEntityDetailsFromReplicaResponse => dto;

// ErpFieldsResponse mapper (identity - external API response)
export const toErpFieldsResponse = (dto: ErpFieldsResponse): ErpFieldsResponse => dto;
